document.addEventListener("DOMContentLoaded", () => {
  const hotspot = document.querySelector(".gol-hotspot");
  const glow = document.querySelector(".gol-glow");

  if (!hotspot || !glow) return;

  hotspot.addEventListener("click", (e) => {
    e.preventDefault();

    glow.classList.add("portal-open");

    setTimeout(() => {
      window.location.href = hotspot.href;
    }, 900);
  });
});